/**
 * Pure mapping helper: ObservabilityUser → Sentry user object.
 * Kept separate so it is unit-testable without importing `@sentry/react`.
 *
 * BROWSER-SAFE.
 */
export function buildSentryUser(user) {
    return {
        id: user.id,
        email: user.email,
        username: user.username,
        role: user.role,
        vessel_id: user.vesselId,
        vessel_name: user.vesselName,
    };
}
